import React, { useContext } from 'react'
import Container from '@embracesbs/component-container/Container'
import Sidebar2 from '@embracesbs/component-sidebar2/Sidebar2'
import SidebarItem from '@embracesbs/component-sidebaritem/SidebarItem'

import { Link, useLocation } from 'react-router-dom'
import { AuthRoleContext } from '../Auth/AuthRoleContext'
import TmaLogo from '../Common/TmaLogo'
import SidebarAdminTools from './SidebarAdminTools'
import { isNavItemActive, navItemsFor, SIDEBAR_ITEMS } from './navigation'

const MainMenu: React.FC = () => {
  const roles = useContext(AuthRoleContext)
  const location = useLocation()

  const handleLogout = () => {
    // Clear all storage (this removes MSAL tokens and cache)
    sessionStorage.clear()
    localStorage.clear()

    // Reload the page to reinitialize MSAL without cached accounts
    // This will send the user to the login page since they're no longer authenticated
    window.location.href = '/login'
  }

  return (
    <Sidebar2 style={{ overflow: 'visible', zIndex: 2, paddingTop: 0, paddingBottom: 0 }}>
      <Container isVertical isFullHeight>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'var(--app-height, 100vh)',
            width: '100%'
          }}
        >
          {/* TMA logo: a mark, not a control. Home is a real item below, where it
              can show which page you are on like every other item. */}
          <section style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // 16px + 20px logo + 16px = 52px, matching the SidebarItem height
                // (20px icon + theme spacing.$5 padding top/bottom).
                padding: '16px 12px',
                boxSizing: 'border-box'
              }}
            >
              <TmaLogo height={20} color='#6b96ff' accentColor='#3f74f0' />
            </div>
          </section>

          {/* The whole rail: three items, the same three on every page. The
              developer tools live behind the Developer center (navigation.ts). */}
          <section
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              flex: 1
            }}
          >
            {navItemsFor(SIDEBAR_ITEMS, !!roles?.isAdmin).map((item) => (
              <Link to={item.path} key={item.id} style={{ textDecoration: 'none' }}>
                <SidebarItem
                  id={item.id}
                  title={item.title}
                  icon={{ iconName: item.icon }}
                  style={{ wordSpacing: 10 }}
                  isActive={isNavItemActive(item, location.pathname)}
                />
              </Link>
            ))}
          </section>

          {/* Bottom section: settings + admin tools + logout button */}
          <section style={{ display: 'flex', flexDirection: 'column' }}>
            <Link to={`/settings`} key='settings' style={{ textDecoration: 'none' }}>
              <SidebarItem
                id='settings'
                title='Settings'
                icon={{ iconName: 'Cog' }}
                style={{ wordSpacing: 10 }}
                isActive={location.pathname.startsWith('/settings')}
              />
            </Link>
          </section>
          <SidebarAdminTools />
          <section
            style={{
              display: 'flex',
              flexDirection: 'column',
              paddingBottom: '4px'
            }}
          >
            <div
              onClick={handleLogout}
              style={{ cursor: 'pointer', textDecoration: 'none' }}
              data-tooltip-id='global-tooltip'
              data-tooltip-content='Logout'
            >
              <SidebarItem id='logout' title='Logout' icon={{ iconName: 'Logout1' }} style={{ wordSpacing: 10 }} isActive={false} />
            </div>
          </section>
        </div>
      </Container>
    </Sidebar2>
  )
}

export default MainMenu
